import { User } from './user';
import { Company } from "./company";
import { Contract } from "./contract";

export class Customer extends User {

  company?: Company;
  contracts?: Contract[];

}
